import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'facility-surrounding',
  data: function () {
    return {
      isFacility: true,
      isFacilityPerson: false,
      shopId: null,
      shop: null,
      facilityList: null,
      shopList: null,
      searchShops: false
    }
  },
  created () {
    if (this.$router.currentRoute.query.searchShops === true) {
      this.searchShops = true
      this.facilityList = this.$store.getters.searchFacilitiesByShop
      this.shopList = this.$store.getters.searchFacilitiesShopList
      this.getSelectShop()
    } else {
      this.shopId = this.$store.getters.currentShopId
      if (utils.isPresent(this.shopId)) {
        this.getShop(this.shopId)
      } else {
        this.goPrev()
      }
    }
    if (this.$route.name === 'facilityPersonSurrounding') {
      this.isFacility = false
      this.isFacilityPerson = true
    }
  },
  mounted: function () {
    // this.initGoogleMaps()
  },
  computed: {
    selectedFacilities () {
      return this.$store.getters.selectedFacilities
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    shops () {
      return this.$store.getters.shops
    },
    searchShopsCheck () {
      if (this.searchShops === false) {
        return true
      } else if ((this.searchShops === true) && (!this.facilityList)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    /** 店舗情報取得 */
    getShop: function (shopId) {
      this.$store.dispatch('SHOP_GET', {data: {shop_id: shopId}})
      .then(
        (res) => {this.searchCallback(res)},
        () => {this.goPrev()}
      )
    },
    getSelectShop: function () {
      this.$store.dispatch('SHOP_SELECT_GET', {data: {shop_list: this.shopList}})
      .then(
        (res) => {this.searchCallback(res)},
        () => {this.goPrev()}
      )
    },
    searchCallback: function (data) {
      this.shop = data.data
      if (this.$router.currentRoute.query.searchShops === true) {
        this.initGoogleMapsByShop()
      } else {
        this.initGoogleMaps()
      }
    },
    /** コールバック */
    initGoogleMaps: function() {
      var markaList = []
      if (utils.isPresent(this.selectedFacilities) && this.selectedFacilities.length > 0) {
        // 施設・個人宅 マーカー
        for (var i = 0; i < this.selectedFacilities.length; i++) {
          var facility = this.selectedFacilities[i]['attributes']
          var address = ''
          if (utils.isPresent(facility['address1'])) {
            address += facility['address1']
          }
          if (utils.isPresent(facility['address2'])) {
            address += facility['address2']
          }
          // var icon = constant.shopIcons[i % constant.shopIcons.length]
          markaList.push({
            lat:     facility['map-lat'],
            lng:     facility['map-lng'],
            zoom:    facility['map-zoom'],
            title:   facility['facility-name'],
            address: address,
            // icon:    icon
          })
        }

        // 店舗 マーカー
        var shop = this.shop['attributes']
        var shop_address = ''
        if (utils.isPresent(shop['address1'])) {
          shop_address += shop['address1']
        }
        if (utils.isPresent(shop['address2'])) {
          shop_address += shop['address2']
        }

        markaList.push({
          lat:     shop['map-lat'],
          lng:     shop['map-lng'],
          zoom:    shop['map-zoom'],
          title:   shop['shop-name'],
          address: shop_address,
          icon:    constant.currentShopIcon
        })
      }
      utils.googleMapMarkaOnlyEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        map_default: constant.map_default,
        markaList:   markaList,
        logoChange: false,
        logoLinkChange: false,
        showMarkerInfo: true,
      })
    },
    initGoogleMapsByShop: function () {
      var shopListCnt = 0
      var markaList = []
      if (utils.isPresent(this.facilityList) && this.facilityList.length > 0) {
        // 施設・個人宅 マーカー
        for (var i = 0; i < this.facilityList.length; i++) {
          var facility = this.facilityList[i]

          if (this.shopList.data[shopListCnt] !== facility['shop_id']) {
            shopListCnt += 1
          }
          var address = ''
          if (utils.isPresent(facility['address1'])) {
            address += facility['address1']
          }
          if (utils.isPresent(facility['address2'])) {
            address += facility['address2']
          }
          // var icon = constant.shopIcons[i % constant.shopIcons.length]
          markaList.push({
            lat:     facility['map_lat'],
            lng:     facility['map_lng'],
            zoom:    facility['map_zoom'],
            title:   facility['facility_name'],
            address: address,
            icon:    constant.resIcons[shopListCnt]
          })
        }

        // 店舗 マーカー
        for (var i = 0; i < this.shop.length; i++) {
          var shop = this.shop[i]['attributes']
          var shop_address = ''
          if (utils.isPresent(shop['address1'])) {
            shop_address += shop['address1']
          }
          if (utils.isPresent(shop['address2'])) {
            shop_address += shop['address2']
          }

          markaList.push({
            lat:     shop['map-lat'],
            lng:     shop['map-lng'],
            zoom:    shop['map-zoom'],
            title:   shop['shop-name'],
            address: shop_address,
            icon:    constant.shopIcons[i]
          })
        }
        
      }
      
      utils.googleMapMarkaOnlyEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        map_default: constant.map_default,
        markaList:   markaList,
        logoChange: false,
        logoLinkChange: false,
        showMarkerInfo: true,
      })
      
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type, keep: 'true'} })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type}})
    },
    
    goNext: function (id) {
      this.$router.push({ path: '/facilities/detail/' + id ,query: { type: this.$router.currentRoute.query.type}})
    },
    goPrev: function () {
      if (this.isFacility) {
        this.$router.push({ path: '/facilities' ,query: { type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.isFacilityPerson) {
        this.$router.push({ path: '/facility_persons' ,query: { type: this.$router.currentRoute.query.type, keep: 'true'}})
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/scripts/facility-surrounding.js